// @flow
import React from 'react';
import classNames from 'classnames';
import { StringUtil } from 'utils/StringUtil';

type Props = {
  count: number,
  type: 'big' | 'medium',
  className?: string,
  style?: Object,
};

export const Counter = (props: Props) => {
  const { count, type = 'big', className = '', style } = props;
  const displayValue = StringUtil.zeroPad(count, 2);

  const counterClass = classNames(className, {
    'big-counter': type === 'big',
    'medium-counter': type === 'medium',
  });

  return (
    <span className={counterClass} data-count={displayValue} style={style}>
      {displayValue}
    </span>
  );
};
